import {LoginController} from './components/login-form/controller';
import {LoginConfirmationController} from './components/login-confirmation/controller';
import {IRouteStore} from '../../router/routing.infra';
import {getRootStore, createFieldModel} from '../../app.bootstrap';

export interface ILoginStore extends IRouteStore {
    loginController: LoginController;
    loginConfirmationController: LoginConfirmationController;
    localizationService: any;
    dispose(): void;
}

export class LoginStore implements ILoginStore {
    public loginController: LoginController;
    public loginConfirmationController: LoginConfirmationController;
    public localizationService: any;

    constructor() {
        const rootStore = getRootStore();

        this.localizationService = rootStore.localizationService;

        this.loginConfirmationController = new LoginConfirmationController(rootStore.localizationService.translate);

        this.loginController = new LoginController(
            rootStore.localizationService.translate,
            rootStore.applicationService,
            rootStore.redirectionService,
            createFieldModel,
            this.loginConfirmationController,
            rootStore.browserUtilsService,
            rootStore.userService
        );
    }

    dispose(): void {
        // Cleanup if needed
    }
}
